import { useQuery } from '@tanstack/react-query';
import fallbackRuntimeConfig from 'src/configs/front-end-runtime-config.json';
import { CommonResponse } from 'src/model/common';
import { IFERuntimeConfig } from 'src/model/fe-runtime-config';
import { getRequest } from 'src/services/api/http';
import {
  LINK_FE_RUNTIME_CONFIG
} from 'src/utils/constants/config';

const QUERY_RUNTIME_CONFIG = 'QUERY_RUNTIME_CONFIG';

export const useQueryRuntimeConfig = () => {
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [QUERY_RUNTIME_CONFIG],
    queryFn: () => {
      return getRequest(LINK_FE_RUNTIME_CONFIG, {}, new CommonResponse({ data: fallbackRuntimeConfig })) as Promise<
        IResponse<IFERuntimeConfig>
      >;
    },
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    initialData: new CommonResponse({ data: fallbackRuntimeConfig })
  });

  return {
    data,
    isFetching,
    isFetched
  };
};
